import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import Synergy from '@/roc/wonders/base/Synergy';
import TriggeredProduction from '@/roc/effects/Production/TriggeredProduction';
import ProcCondition from '@/roc/effects/Production/ProcCondition';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import EraType from '@/roc/era/EraType';

const SherwoodForest = {
  id: '46',
  name: 'Sherwood Forest',
  era: EraType.earlyRome,
  icon: 'sherwood',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.GREAT_EMPIRE,
  kind: WonderKind.FORTRESS | WonderKind.NATURE,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.RANGED_HIT_POINT_MOD,
      EffectAmount.asPerLevel([
        2.5,
        3.2,
        3.7,
        4.2,
        4.5,  // 5
        4.9,
        5.2,
        5.4,
        5.7,
        5.9,  // 10
        6.2,
        6.4,
        6.6,
        6.8,
        7,  // 15
        7.1,
        7.3,
        7.5,
        7.6,
        7.8,  // 20
        7.9,
        8.1,
        8.2,
        8.4,
        8.5,  // 25
        8.6,
        8.8,
        8.9,
        9,
        9.1   // 30
      ]),
      '%',
    ),
    new TriggeredProduction(
      EffectAmount.asFlat(1),
      ProcCondition.asCompleteBattle(),
      ProductionDuration.asDaily(),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.CHEST),
    ),
  ]),
  synergies: [
    {
      effectIndex: 0,
      mod: Synergy.asFlat(2).withKind(WonderKind.FORTRESS),
      effect: null,
    }
  ],
};

export default SherwoodForest;
